import { colors } from '../../colors';
var para = {
  messageColor: colors.dustyTeal
};
export default para;